const BaseComponent = require( 'common/home/view' );
const Server = require( 'helper/server' );

class Home extends BaseComponent {
  constructor() {
    super();
    this.init();
  }

  init() {
    // this.initElegantBanner();
    $('#floatingWindow-close').click(function () {
      $('#floatingWindow').hide();
    });
    this.showFloat();
  }
  async showFloat () {
    const res = await Server.queryFloating({siteId: 77});
    const { floatingType, floatingPicture, description, url} = res;
    let str = "";
    if (floatingType){
      if ( floatingType === 2){
        str = url ? `<a href="${url}"><p>${description}</p></a>` : `<p>${description}</p>`;
      } else {
        str = url ? `<a href="${url}"><img src="${floatingPicture}"/></a>` : `<img src="${floatingPicture}"/>`;
      }
      $("#floatingWindow-content").html(str);
    } else {
      $("#floatingWindow").hide();
    }
  }
  initElegantBanner() {
    this.elegantBannerCount = 0;
    let timer = null;
    if (timer) {
      clearInterval( timer );
    }
    Server.purchaseHomeMembers().then( ( { data = [] } ) => {
      let html = '';
      $.map( data, ( item ) => {
        const { cover, memberName, id, orgName } = item;
        const img = cover ? `<img alt="${ orgName }-${ memberName }" src="${ cover }" />` : `<p data-v="${ orgName }-${ memberName }" class="noData">暂无图片</p>`;
        html += `<li class="memberPhotos_${ id }">
              <div class="img-wrap">
                ${ img }
              </div>
              <p>
                <span>${ orgName }</span>
              </p>
            </li>`;
      } );
      html += html;
      const memberPhotosWrap = this.$el.find( '.memberPhotos' );
      memberPhotosWrap.append( html );
      if (data.length < 5) {
        return false;
      }

      setInterval( () => {
        this.elegantBannerCount ++;
        this.elegantBannerMove( data.length );
      }, 3000 );

      const thisObj = this;
      $('#memberPhoto-left').click(function (){
        console.log('thisObj', thisObj, thisObj.elegantBannerCount);
        thisObj.elegantBannerCount ++;
        thisObj.elegantBannerMove(data.length);
      });
      $('#memberPhoto-right').click(function (){
        console.log('thisObj', thisObj, thisObj.elegantBannerCount);
        thisObj.elegantBannerCount -- ;
        thisObj.elegantBannerMove(data.length);
      });
    } );
  }

  elegantBannerMove( size) {
    const memberPhotos = this.$el.find( '.memberPhotos' );
    if (this.elegantBannerCount > size || this.elegantBannerCount === 0) {
      memberPhotos.css( {
        left: 0
      } );
      this.elegantBannerCount = 1;
    }
    console.log('this.elegantBannerCount', this.elegantBannerCount);
    memberPhotos.stop().animate(
      {
        left: - this.elegantBannerCount * 235
      },
      440
    );
  }
}

module.exports = Home;
